import React from "react";
import { ColorInput, ColorInputProps } from "@mantine/core";

import styles from "@scss/custom-components/form-fields-dropdowns.module.scss";

interface CustomColorInputProps extends ColorInputProps {}

export const CustomColorInput: React.FC<CustomColorInputProps> = ({
  variant = "default",
  classNames = {},
  ...props
}) => {
  const variantDropdownClasses: Record<string, string> = {
    default: styles["dropdown--default"],
    dark: styles["dropdown--dark"],
    darker: styles["dropdown--darker"],
    sky: styles["dropdown--sky"],
  };

  const customDropdownClass = variantDropdownClasses[variant] || "";

  return (
    <ColorInput
      variant={variant}
      classNames={{
        ...classNames,
        dropdown: customDropdownClass,
      }}
      {...props}
    />
  );
};
